import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { formatMsisdn } from "../../../../tools/tools";
import { ShopReceipt, toman } from "../../../auxiliary/shop/ShopPage";

const DCFinal = () => {
	const [t] = useTranslation("global");
	const { state } = useLocation();
	// the charge service answers with the same ep* field names as the package service
	return (
		<ShopReceipt
			title={t("directCharge.title")}
			prefix="sp"
			purchase={state?.purchase}
			rows={[
				["نوع سرویس", <>فروش شارژ</>],
				["شماره سیم کارت", <span dir="ltr">{formatMsisdn(state?.epmsisdn?.toString())}</span>],
				["مبلغ شارژ", toman(state?.amount)],
				["کد پیگیری", <span dir="ltr">{state?.eppurchasefollowupcode}</span>],
			]}
		/>
	);
};

export default DCFinal;
